import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { locales, namespaces, resources, type SupportedLocale } from './resources';

export { locales, namespaces, resources };
export type { SupportedLocale };
export { useTranslation, Trans } from 'react-i18next';

let initialized = false;

export function initI18n(opts?: { lng?: SupportedLocale; detect?: boolean }) {
  if (initialized) return i18next;
  initialized = true;

  const instance = i18next;
  if (opts?.detect !== false) instance.use(LanguageDetector);
  instance.use(initReactI18next);

  instance.init({
    resources,
    ns: [...namespaces],
    defaultNS: 'common',
    fallbackLng: 'en',
    supportedLngs: locales.map((l) => l.code),
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'yorukiri-locale',
    },
    ...(opts?.lng ? { lng: opts.lng } : {}),
  });

  return instance;
}

export function setLocale(code: SupportedLocale) {
  return i18next.changeLanguage(code);
}

export function getLocale(): SupportedLocale {
  const cur = i18next.resolvedLanguage ?? i18next.language ?? 'en';
  const short = cur.split('-')[0] as SupportedLocale;
  return (locales.find((l) => l.code === short)?.code ?? 'en') as SupportedLocale;
}

export { default as i18n } from 'i18next';
